<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">账户设置</span>
            <span class="bar-tools">
                <input type="text" class="h-input h-input-s" style="width:180px" placeholder="请输入编码或名称"
                       v-model="keyword" @keyup.enter="loadList">
                <Button size="s" @click="loadList">查询</Button>
                <Button color="primary" size="s" @click="add">新增</Button>
            </span>
        </div>
        <div class="h-panel-body">
            <Tabs :datas="tabDatas" v-model="type" @change="loadList" class-name="h-tabs-card"></Tabs>
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:120px">编码</th>
                    <th style="min-width:160px">账户名称</th>
                    <th v-if="type === '2'" style="width:180px">关联银行</th>
                    <th style="width:110px">币别</th>
                    <th v-if="type === '2'" style="width:180px">银行卡号</th>
                    <th style="min-width:160px">会计科目</th>
                    <th style="width:120px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td>{{item.code}}</td>
                    <td>{{item.name}}</td>
                    <td v-if="type === '2'">{{item.bankName}}</td>
                    <td>{{item.currencyName}}</td>
                    <td v-if="type === '2'">{{item.bankAccount}}</td>
                    <td>{{item.subjectCode}} {{item.subjectName}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td :colspan="type === '2' ? 7 : 5" class="text-center padding">暂无数据</td>
                </tr>
                </tbody>
            </table>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : '新增'}}账户</div>
            <Form ref="form" v-width="450" :labelWidth="110" :model="form" :rules="validationRules">
                <FormItem label="编码" prop="code"><input type="text" v-model="form.code"></FormItem>
                <FormItem label="名称" prop="name"><input type="text" v-model="form.name"></FormItem>
                <FormItem label="账户类型">
                    <Select v-model="form.type" :datas="typeOptions" keyName="id" titleName="name" :deletable="false"></Select>
                </FormItem>
                <FormItem label="关联银行" v-if="String(form.type) === '2'">
                    <Select v-model="form.bankName" :datas="banks" :deletable="false"></Select>
                </FormItem>
                <FormItem label="银行账号" v-if="String(form.type) === '2'">
                    <input type="text" v-model="form.bankAccount">
                </FormItem>
                <FormItem label="币别">
                    <Select v-model="form.currencyId" :datas="currencyOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="会计科目">
                    <Select v-model="form.subjectId" :datas="subjectOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="期初余额">
                    <NumberInput v-model="form.initBalance" :precision="2"></NumberInput>
                </FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit" :loading="loading">{{form.id ? '更新' : '保存'}}</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>
    </app-content>
</template>

<script>
const emptyForm = {
    id: null, code: '', name: '', type: 1, bankName: '', bankAccount: '',
    currencyId: null, subjectId: null, initBalance: 0, remark: ''
};

export default {
    name: 'CashierAccount',
    data() {
        return {
            datas: [],
            keyword: '',
            type: '1',
            tabDatas: { '1': '现金', '2': '银行存款' },
            typeOptions: [{ id: 1, name: '现金' }, { id: 2, name: '银行存款' }],
            showForm: false,
            loading: false,
            form: Object.assign({}, emptyForm),
            subjectOptions: [],
            currencyOptions: [],
            banks: [],
            validationRules: { required: ['code', 'name'] }
        };
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        loadOptions() {
            this.$api.funds.journal.options().then(({ data }) => {
                this.banks = data.banks || [];
                this.currencyOptions = (data.currencies || []).map(c => ({ id: c.id, name: c.name }));
                this.subjectOptions = (data.subjects || []).map(s => ({ id: s.id, name: s.code ? `${s.code} ${s.name}` : s.name }));
            });
        },
        loadList() {
            this.$api.funds.account.list({ type: this.type, keyword: this.keyword }).then(({ data }) => {
                this.datas = data || [];
            });
        },
        add() {
            this.form = Object.assign({}, emptyForm, { type: Number(this.type) });
            this.showForm = true;
        },
        edit(item) {
            this.form = Object.assign({}, emptyForm, item);
            this.showForm = true;
        },
        submit() {
            if (!this.$refs.form.valid().result) return;
            this.loading = true;
            this.$api.funds.account[this.form.id ? 'update' : 'save'](this.form).then(() => {
                this.loading = false;
                this.showForm = false;
                this.loadList();
                this.$Message.success('保存成功');
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除账户「${item.name}」?`).then(() => {
                this.$api.funds.account.delete(item.id).then(() => this.loadList());
            });
        }
    },
    mounted() {
        this.loadOptions();
        this.loadList();
    }
};
</script>

<style scoped lang="less">
    .bar-tools {
        margin-left: 20px;
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }
</style>
